<div>
  <!-- Photo by <a href="https://unsplash.com/@gilleslambert?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Gilles Lambert</a> on <a href="https://unsplash.com/photos/silhouette-photo-of-person-holding-smartphone-pb_lF8VWaPU?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
  <h1 class="webapp-title">{{getTitle()}}</h1>

  <app-card-image-overlay [cardInfo]="convertData()"></app-card-image-overlay>
  
  <span class="card-category" *ngFor="let category of data.categories">{{category}}</span>

  <p>{{data.description}}</p>
  <h2 class="webapp-title-secondary" *ngIf="data.longPar">Además...</h2>
  <p>{{data.longPar}}</p>
  
  <span *ngFor="let obj of data.listData">
    <h3>{{obj.subtitle}}</h3>
    <p>{{obj.text}}</p>
  </span>
    
</div>